import axios from "axios";

const state = {
    subscription: null,
    subscriptionError: null,
};

const getters = {
    getSubscription: (state) => state.subscription,
    getSubscriptionError: (state) => state.subscriptionError,
};

const actions = {
    async checkSubscription({ commit }, storeId) {
        try {
            const response = await axios.get(`https://lytningtomcat.chrilantech.com/SubscriptionManager/api/customer/getStoreByID/${storeId}`);
            commit("setSubscription", response.data);
            commit("setSubscriptionError", null);
        } catch (error) {
            commit("setSubscription", null);
            commit("setSubscriptionError", "Error checking subscription.");
        }
    },
};

const mutations = {
    setSubscription(state, subscription) {
        state.subscription = subscription;
    },
    setSubscriptionError(state, error) {
        state.subscriptionError = error;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
